import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'component-utilities/intl';
import displayName from 'component-lib/displayName';

import styles from '../Forms.scss';

function TextareaCounter(props) {
    const { remaining } = props;
    const className = `character-count${remaining < 0 ? '-over' : ''}`;

    return (
        <div className={styles['form-field-add-on']}>
            <span className={styles[className]}>
                <FormattedMessage
                    id="components.forms.soft_limit_text_area.characters_remaining"
                    values={{
                        remaining: String(remaining),
                    }}
                />
            </span>
        </div>
    );
}

TextareaCounter.displayName = displayName('Forms/Textarea/TextareaCounter');

TextareaCounter.propTypes = {
    remaining: PropTypes.number.isRequired,
};

export default TextareaCounter;
